import MerchantModal from './MerchantModal';

export default function MerchantCreateModal({ open, onClose, value, onChange, onSubmit, submitting }) {
  const rifPrefix = (value.rif.match(/^[JVEGP]/) || ['J'])[0];
  const rifDigits = value.rif.replace(/^[JVEGP]-?/, '');

  const setField = (k, v) => onChange({ ...value, [k]: v });

  const footer = (
    <>
      <button onClick={onClose} className="px-4 py-2 text-sm text-gray-600 border rounded-lg hover:bg-gray-100">
        Cancelar
      </button>
      <button
        data-testid="submit-create-merchant"
        onClick={onSubmit}
        disabled={submitting}
        className="px-4 py-2 text-sm text-white rounded-lg disabled:opacity-50"
        style={{ backgroundColor: '#003594' }}
      >
        {submitting ? 'Creando...' : 'Crear Comercio'}
      </button>
    </>
  );

  return (
    <MerchantModal
      open={open}
      onClose={onClose}
      title="Crear Nuevo Comercio"
      subtitle="Se creara con proyecto + API Keys (QA + Produccion)"
      footer={footer}
      testid="merchant-create-modal"
    >
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nombre de Persona o Empresa *</label>
          <input
            data-testid="new-merchant-company"
            type="text"
            value={value.company_name}
            onChange={(e) => setField('company_name', e.target.value)}
            className="w-full px-3 py-2 border rounded-lg text-sm"
            placeholder="Ej: Mi Empresa CA"
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
            <input
              data-testid="new-merchant-email"
              type="email"
              value={value.email}
              onChange={(e) => setField('email', e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-sm"
              placeholder="admin@empresa.com"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Contrasena *</label>
            <input
              data-testid="new-merchant-password"
              type="text"
              value={value.password}
              onChange={(e) => setField('password', e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-sm"
              placeholder="Min 8 caracteres"
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Número de identificación</label>
            <div className="flex">
              <select
                data-testid="new-merchant-rif-prefix"
                value={rifPrefix}
                onChange={(e) => setField('rif', e.target.value + (rifDigits ? '-' + rifDigits : ''))}
                className="px-2 py-2 border border-r-0 rounded-l-lg text-sm bg-gray-50"
              >
                <option value="J">J</option>
                <option value="V">V</option>
                <option value="E">E</option>
                <option value="G">G</option>
                <option value="P">P</option>
              </select>
              <input
                data-testid="new-merchant-rif"
                type="text"
                value={rifDigits}
                onChange={(e) => setField('rif', rifPrefix + (e.target.value ? '-' + e.target.value : ''))}
                className="flex-1 min-w-0 px-3 py-2 border rounded-r-lg text-sm"
                placeholder="12345678-9"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Telefono</label>
            <input
              data-testid="new-merchant-phone"
              type="text"
              value={value.phone}
              onChange={(e) => setField('phone', e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-sm"
              placeholder="04141234567"
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nombre del Proyecto</label>
          <input
            data-testid="new-merchant-project"
            type="text"
            value={value.project_name}
            onChange={(e) => setField('project_name', e.target.value)}
            className="w-full px-3 py-2 border rounded-lg text-sm"
            placeholder="Se genera automaticamente si se deja vacio"
          />
        </div>
      </div>
    </MerchantModal>
  );
}
